// ============================================================================
// GL REPLACEMENT TRANSACTION SERVICE
// ============================================================================

import { get, post, put, patch, del } from '../client/axiosClient';
import { glReplacementEndpoints } from '../endpoints/glReplacement.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  PaginatedResponse,
  ID,
} from '../types';
import { transformPaginatedResponse } from '../types/common.types';
import type {
  GlReplacementTransaction,
  CreateGlReplacementPayload,
  UpdateGlReplacementPayload,
  GlReplacementFilterParams,
  PendingReplacementCheck,
} from '../types/glReplacement.types';

class GlReplacementService {
  async getAll(params?: GlReplacementFilterParams): Promise<PaginatedResponse<GlReplacementTransaction>> {
    const endpoint = params
      ? buildEndpointWithQuery(glReplacementEndpoints.list(), params)
      : glReplacementEndpoints.list();
    const response = await get(endpoint);
    return transformPaginatedResponse<GlReplacementTransaction>(response.data);
  }

  async getById(id: ID): Promise<ApiResponse<GlReplacementTransaction>> {
    const response = await get<ApiResponse<GlReplacementTransaction>>(glReplacementEndpoints.getById(id));
    return response.data;
  }

  async create(payload: CreateGlReplacementPayload): Promise<ApiResponse<GlReplacementTransaction>> {
    const response = await post<ApiResponse<GlReplacementTransaction>>(glReplacementEndpoints.create(), payload);
    return response.data;
  }

  async update(id: ID, payload: UpdateGlReplacementPayload): Promise<ApiResponse<GlReplacementTransaction>> {
    const response = await put<ApiResponse<GlReplacementTransaction>>(glReplacementEndpoints.update(id), payload);
    return response.data;
  }

  async submit(id: ID): Promise<ApiResponse<GlReplacementTransaction>> {
    const response = await patch<ApiResponse<GlReplacementTransaction>>(glReplacementEndpoints.submit(id), {});
    return response.data;
  }

  async delete(id: ID): Promise<ApiResponse<void>> {
    const response = await del<ApiResponse<void>>(glReplacementEndpoints.delete(id));
    return response.data;
  }

  async checkPending(mappingId: string): Promise<ApiResponse<PendingReplacementCheck>> {
    const response = await get<ApiResponse<PendingReplacementCheck>>(glReplacementEndpoints.checkPending(mappingId));
    return response.data;
  }
}

export const glReplacementService = new GlReplacementService();
export default glReplacementService;
